export default __webpack_public_path__ + "static/media/thumbnail3.ccb7588f.jpg";